
          <angular-editor id='editor' [(ngModel)]="htmlContent" [config]="editorConfig"></angular-editor>

          <div fxLayoutAlign="center" class="w-100 mt-3">
            <button mat-raised-button color="accent" class="mat-elevation-z6 ml-3"  (click)="onSave($event)">{{
        'COMMON.SAVE' | translate }}</button>
  
            <button mat-raised-button class="mat-elevation-z6 ml-3" type="button" (click)="onCancel($event)">{{
        'COMMON.CANCEL' | translate }}</button>
          </div>

         <!-- <p [innerHTML]="htmlContent"></p> -->

         
